import getVimeoUrlRegex from "./getVimeoUrlRegex";
import getYouTubeUrlRegex from "./getYouTubeUrlRegex";

export default ({ videoUrl }) => {
  if (getYouTubeUrlRegex().test(videoUrl)) return 'youtube';
  if (getVimeoUrlRegex().test(videoUrl)) return 'vimeo';

  return 'file';
};
